import { WbsItemTypeVO } from '../../../../../../domain/value-object/WbsItemTypeVO'
import { toCommentDataType } from '../../../../../../store/comments'
import Comments from '../../../../../containers/Comment/index'

type DiscussionTabProps = {
  functionUuid: string
  projectUuid: string
  uuid: string
  wbsItemType: WbsItemTypeVO
}
export const DiscussionTab = ({
  functionUuid,
  projectUuid,
  uuid,
  wbsItemType,
}: DiscussionTabProps) => {
  return (
    <Comments
      applicationFunctionUuid={functionUuid}
      projectUuid={projectUuid}
      dataUuid={uuid}
      dataType={toCommentDataType(wbsItemType)}
    />
  )
}
